import { Component, OnInit, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { EpinManagerService } from '../../angular-wallet-base/services/epin-manager.service';

@Component({
  selector: 'app-price-tiers',
  templateUrl: './price-tiers.component.html',
  styleUrls: ['./price-tiers.component.scss'],
})
export class PriceTiersComponent implements OnInit {
  public tiers: any = [];
  @Input() amount;
  @Input() tokenSymbol;
  @Input() mode = 'mobile';

  constructor(private modal: ModalController,
              private epin: EpinManagerService) { }

  async ngOnInit() {
    this.tiers = await this.epin.getPriceTiers(this.tokenSymbol);
  }

  closeModal() {
    this.modal.dismiss();
  }

}
